import BunkeyAPI from "../api/BunkeyAPI";
import {
  ASSET_EXPLORE_UPLOAD_GET_DATA,
  ASSET_EXPLORE_UPLOAD_GET_DATA_FAILURE,
  ASSET_EXPLORE_UPLOAD_GET_DATA_SUCCESS,
  CLEAN_DATA_BACK,
} from "../constants/assets-explore-upload-types";
import store from "../store";
import {
  permissionsDefault,
  validateImageSpecialExtensions,
} from "../utils";
import { goToPage } from "./SearchAction";

export const cleanDataBack = () => {
  return dispatch => {
    dispatch({
      type: CLEAN_DATA_BACK,
    })
  }
}

export const getExploreUpload = (
  workclient,
  folder,
  page = 1,
  order,
  isFetching = true,
  data = [],
  newLimit = 1000
) => {
  const user = store.getState().authUser.user;
  let isShared = store
    .getState()
    .assetsShared.data.find((r) => r._id === folder);
  if (!isShared) {
    isShared = store
      .getState()
      .assetsExplore.data.find((r) => r._id === folder && r.isShared === true);
  }
  return (dispatch) => {
    const { orderBy, limit } = store.getState().assetsExplore;
    const pageToGo = newLimit !== limit ? 1 : page;
    const filterOrder =
      order !== orderBy && order && order !== "" ? order : orderBy;

    dispatch(goToPage(pageToGo));

    dispatch({
      type: ASSET_EXPLORE_UPLOAD_GET_DATA,
      payload: {
        folder,
        isFetching,
        data,
      },
    });

    BunkeyAPI({
      url: `/clients/${workclient}/folders/${folder}?page=${pageToGo}&limit=${newLimit}&orderBy=${filterOrder}&isShared=${
        isShared ? true : false
      }`,
      method: "GET",
    })
      .then((resp) => {
        dispatch({
          type: ASSET_EXPLORE_UPLOAD_GET_DATA_SUCCESS,
          payload: {
            user,
            headers: resp.headers,
            page: pageToGo,
            limit: newLimit,
            orderBy: filterOrder,
            data: resp.data
              .map((r) => {
                return {
                  _id: r._id,
                  type: validateImageSpecialExtensions(r.originalURL)
                    ? "document"
                    : r.type,
                  name: r.name,
                  lowQualityURL: r.lowQualityURL,
                  mediaQualityURL: r.mediaQualityURL,
                  originalURL: r.originalURL,
                  metadata: r.metadata,
                  parents: r.parents,
                  createdAt: r.createdAt,
                  group: r.group,
                  user:
                    r.user && r.username
                      ? { id: r.user, name: r.username }
                      : { id: "", name: "" },
                  isShared: r.isShared,
                  tagProtocol: r.tagProtocol,
                  longDescription: r.longDescription,
                  objectGroups: r.objectGroup,
                  fileSizeFormat: r.fileSizeFormat,
                  matrix: permissionsDefault().map((def) => {
                    const exists = r.group.find((r) =>
                      r.permissions.find(
                        (item) =>
                          item.action === def.action && item.enabled === true
                      )
                    );
                    return {
                      action: def.action,
                      enabled: exists ? true : false,
                    };
                  }),
                  uuid: r.uuid,
                  documentPages: r.documentPages,
                  viewFromHost: r.viewFromHost,
                };
              }),
          },
        });
      })
      .catch((err) => {
        dispatch({
          type: ASSET_EXPLORE_UPLOAD_GET_DATA_FAILURE,
          payload: err,
        });
      });
  };
};
